export default class AssetActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static VIEW_DATA_IN='VIEW_DATA_IN';
  static VIEW_DATA_OUT='VIEW_DATA_OUT';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_ASSET='GET_HELPER_ASSET';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static VOID_DATA="VOID_DATA";

  static submit(){
    return {
      type: AssetActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: AssetActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: AssetActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: AssetActions.VIEW_DATA,
      payload: data
    };
  }

  static viewDataIn(dataIn) {
    return {
      type: AssetActions.VIEW_DATA_IN,
      payload: dataIn
    };
  }

  static viewDataOut(dataOut) {
    return {
      type: AssetActions.VIEW_DATA_OUT,
      payload: dataOut
    };
  }

  static delete(data) {
    return {
      type: AssetActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: AssetActions.SHOW_DATA,
      payload: data
    };
  }
  static error(error){
    return {
      type: AssetActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: AssetActions.SUCCESS_DATA,
    };
  }
  static void(data) {
    return {
      type: AssetActions.VOID_DATA,
      payload: data
    };
    
  }
  static process(){
    return {
      type: AssetActions.PROCESS_DATA,
    };
  }
  static resetList(){
    return {
      type: AssetActions.RESET_LIST,
    };
  }
  static reset(){
    return {
      type: AssetActions.RESET_DATA,
    };
  }
  static helper(helperAsset){
    return {
      type: AssetActions.GET_HELPER_ASSET,
      payload:helperAsset
    };
  }
  
  static errorInternal(error){
    return {
      type: AssetActions.ERROR_SERVER,
      payload: error
    };
  }
}